import { useQuery } from '@tanstack/react-query';
import axios from '../../../services/axiosInstance';

export interface AccountCard {
  id: string;
  name: string;
  resourceName: string;
}

export const useGBPAccountsList = (subjectEmail: string) =>
  useQuery<AccountCard[]>({
    queryKey: ['gbp', 'accounts-list', subjectEmail],
    queryFn: async () => {
      if (!subjectEmail) return [];
      const res  = await axios.get('/api/gbp/accounts', {
        params: { subjectEmail },  
      });
      const list = res.data?.accounts || res.data || [];
      return list.map((acc: any) => {
        const resource = acc.name || "";
        const id       = resource.split("/").pop() || resource;
        return {
          id,
          name:         acc.accountName || id,
          resourceName: resource || `accounts/${id}`,
        };
      });
    },
    enabled:   !!subjectEmail,  
    staleTime: 1000 * 60 * 5,
    retry: 1,
  });